import React from 'react'
import { Card, PageTitle } from './Ui'

export default function AdminAccessDenied({ navigate }) {
  return <>
    <PageTitle eyebrow="ACCESS CONTROL" title="접근 권한이 없습니다" description="현재 관리자 계정에는 이 메뉴의 조회 권한이 부여되어 있지 않습니다." />
    <Card title="권한 확인이 필요합니다"><div className="admin-long-text">SUPER_ADMIN에게 해당 메뉴의 ‘조회’ 권한을 요청해주세요. 조회가 허용되더라도 Excel 다운로드·등록/수정·승인/처리는 별도 권한으로 제어됩니다.</div><div style={{ marginTop: 18 }}><button type="button" className="button primary" onClick={() => navigate('/dashboard')}>대시보드로 이동</button></div></Card>
  </>
}
